import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import Switch from 'react-router-transition-group'
import Fade from '@material-ui/core/Fade'
import GuestLayout from 'components/Layout/GuestLayout'

// Pages
import LoginPage from './Login'
import ForgotPasswordPage from './ForgotPassword'

export default () => (
  <GuestLayout>
    <Switch transition={Fade}>
      <Redirect exact from="/" to="/login" />
      <Route exact path="/forgot-password" component={ForgotPasswordPage} />
      <Route component={LoginPage} />
    </Switch>
  </GuestLayout>
)
